import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { CustomSuggestTerm } from 'ish-core/models/suggest-term/custom-suggest-term.model';

import { customSuggestSearchSuccess } from './custom-search.actions';

interface CustomSuggestSearch {
  searchTerm: string;
  suggests: CustomSuggestTerm[];
}

export const customSearchAdapter = createEntityAdapter<CustomSuggestSearch>({
  selectId: search => search.searchTerm,
});

export type CustomSearchState = EntityState<CustomSuggestSearch>;

const initialState: CustomSearchState = customSearchAdapter.getInitialState({});

export const customSearchReducer = createReducer(
  initialState,
  on(customSuggestSearchSuccess, (state, action) => customSearchAdapter.upsertOne(action.payload, state))
);
